import React from "react";
import { useTranslation } from "react-i18next";
import image from "../../assets/images/logo.png"
import "./style.css";

export const About = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="activity-header">
        <h2>
          {t("navBar.home")} <span>/ {t("navBar.about")}</span>
        </h2>
      </div>
      <div className="about-container">
        <div className="about-text">
          <h1>{t("abouteMe.title")}</h1>
          <p>{t("abouteMe.p1")}</p>
          <p>{t("abouteMe.p2")}</p>
          <p>{t("abouteMe.p3")}</p>
          <p>{t("abouteMe.p4")}</p>
          <p>{t("abouteMe.p5")}</p>
        </div>
        <div className="about-image">
          <img src={image} alt="About" />
        </div>
      </div>
    </>
  );
};
